import React from 'react';

const FBWorkspaceSocket: React.FunctionComponent<{}> = () => null;

export default FBWorkspaceSocket;
